import numeral from 'numeral';

import { NumberFormattingOptions } from './types';
import { getFormatString } from './utils';

export function getFormattedPercentage(
  num: number,
  options: Pick<NumberFormattingOptions, 'decimals' | 'strict'> = {},
) {
  let { decimals, strict } = options;
  let formatString = getFormatString({ decimals, strict });
  return `${numeral(num).format(formatString)}%`;
}
